/* Spanish catalog mirroring locale-invoice-detail-fr-part2.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'inv.pay.originalAmount': 'Importe en {currency}',
  'inv.pay.bankAmountCurrency': 'Importe bancario en {currency}',
  'inv.pay.fxPreview': 'La cuenta por cobrar se liquida por {receivable} {accountingCurrency}. La diferencia con el importe bancario se contabiliza como {kind}: {difference}.',
  'inv.pay.fxGain': 'diferencia de cambio positiva',
  'inv.pay.fxLoss': 'diferencia de cambio negativa',
});
